module.exports = __webpack_public_path__ + "media/images/flags/KE-3e355f1aaa358a4c0d569b44d6deb476.svg";